import { useCallback, useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./App.css";
import {
  ContentContainer,
  MainContainer,
  MainContentWrapper,
} from "./AppStyles";
import { Flex } from "./common/styles";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import { useLocation } from "react-router-dom";
import API_ENDPOINTS from "@/util/api";
import api from "./services/axios_custom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, setRefLists } from "./slices/refListSlice";
import {
  SetReflist,
  SetClientParam,
  isNonEmptyVariable,
  SetSecurityRules,
  SetModulesList,
} from "./util/common_function";
import {
  setBookings,
  setBookingsNull,
  setLastBookingsFromAPI,
} from "./slices/bookingsSlice";
import { setGlobalClientParam } from "./slices/configSlice";
import { fetchClientParams } from "./apis/config/clientParamsApi";
import { setUserDetail, setUserDetailLoading, setUserSecurityUpdated } from "./slices/userDetailDetail";
import { fetchLoginStaffById } from "./apis/security/userDetailApi";
import {
  fetchStaffListAll,
  fetchStaffListAllActive,
  fetchJudgeListAll,
} from "./apis/staff/staffApi";
import useAutoLogout from "./hooks/useAutoLogout";
import useDialog from "./hooks/useDialog";
import Modal from "./common/elements/Modal";
import InternetAlert from "./components/InternetAlert";

const App = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const globalClientParam = useSelector((state) => state?.clientParams?.list);
  const { showDialog } = useDialog();
  const sidebarHiddenRoutes = ["/dashboard"];
  const [isSidebarHiddenForRoute, setIsSidebarHiddenForRoute] = useState(false);
  const [headerHeight, setHeaderHeight] = useState();
  const [isClientParamLoading, setClientParamLoading] = useState(false);
  const [reflist, setReflist] = useState(
    // {
    //   "searchType": "NAME-IN",
    //   "searchValue": ["Race", 'Sex']
    // }
    {
      searchType: "ALL",
      searchValue: [],
    }
  );
  const [user, setUser] = useState(null);
  const [sessionTimeout, setSessionTimeout] = useState(240);
  const [last30MinTimeoutId, setLast30MinTimeoutId] = useState(null);
  const [last30MinTimeout, setLast30MinTimeout] = useState(30 * 1000); // 30 seconds

  const headerRef = useRef();
  const mainContainerRef = useRef();
  // const navigate = useNavigate();

  useEffect(() => {
    globalClientParam?.find((param) => {
      if (
        param.paramContext === "sessionTimeOut" &&
        param.paramName === "Globals"
      ) {
        setSessionTimeout(Number(param.paramValue)); // convert ms to minutes
      }
    });
  }, [globalClientParam]);

  useEffect(() => {
    const sidebarVisible = sidebarHiddenRoutes.includes(
      location.pathname.toLowerCase()
    );
    const isConfigPath = location.pathname.startsWith("/config");
    if (isConfigPath) {
      setIsSidebarHiddenForRoute(true);
    } else {
      setIsSidebarHiddenForRoute(sidebarVisible);
    }
  }, [location?.pathname]);

  const handleLogout = useCallback(async () => {
    try {
      await api.get(API_ENDPOINTS.logout);
    } catch (error) {
      console.error("Logout API failed:", error);
    }

    localStorage.removeItem("allowedMenu");
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    sessionStorage.clear();

    window.location.href = "/login";
  }, []);

  const { showWarning, countdown, setShowWarning, resetTimer } = useAutoLogout(
    handleLogout,
    sessionTimeout,
    300
  );

  // 🔒 Auto logout after 30 minutes of inactivity

  useEffect(() => {
    setHeaderHeight(headerRef?.current?.clientHeight);
  }, [headerRef]);

  let refListinfo = JSON.stringify(reflist);

  useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));
    if (isNonEmptyVariable(loginUser)) {
      setUser(loginUser);
    }
    getLoginStaffDetails();
    setClientParamLoading(true);
    getAllClientParams();
    getRefList();
    getStaffList();
    getJudgeList();
  }, []);

  const getAllClientParams = () => {
    dispatch(fetchClientParams());
    api
      .get(API_ENDPOINTS.clientParams)
      .then((response) => {
        dispatch(setGlobalClientParam(response?.data));
      })
      .catch((error) => {
        console.error(
          "Request failed:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const getRefList = (url = API_ENDPOINTS.refList) => {
    api
      .post(url, refListinfo)
      .then((response) => {
        dispatch(setRefLists(response?.data));
        dispatch(setLoading(false));
        return response?.data;
      })
      .catch((error) => {
        console.error(
          "Request failed:",
          error.response ? error.response.data : error.message
        );
      });
  };
  const getStaffList = () => {
    dispatch(fetchStaffListAllActive())
      .unwrap()
      .then()
      .catch((error) => console.log(error, "error"));
  };
  const getJudgeList = () => {
    dispatch(fetchJudgeListAll())
      .unwrap()
      .then()
      .catch((error) => console.log(error, "error"));
  };
  const getLoginStaffDetails = () => {
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));
    dispatch(setUserDetailLoading(true));
    dispatch(setUserSecurityUpdated(false));
    console.log("api fetch funs")
    dispatch(fetchLoginStaffById(loginUser?.staffId)).then((response) => {
      const { payload } = response;
      const result = processStaffGroupData(payload);
      dispatch(setUserDetail({ ...loginUser, staffGroup: result }));
      dispatch(setUserDetailLoading(false));
    });
  };

  function processStaffGroupData(staffGroup) {
    const combinedData = {
      groups: [],
      securityRulesCriteria: [],
      securityRulesFunctionality: [],
      securityRulesRecords: [],
      clientParams: [],
    };

    staffGroup?.forEach((group) => {
      // Combine security group
      combinedData?.groups?.push({
        groupName: group?.groupName,
        groupId: group?.staffGroupsID,
      });

      // Combine security rules criteria
      group?.securityRulesCriteria?.forEach((criteria) => {
        const existing = combinedData?.securityRulesCriteria.find(
          (c) =>
            c?.securityRulesCriteriaID === criteria?.securityRulesCriteriaID
        );
        if (existing) {
          existing.allowSetting = Math.max(
            existing?.allowSetting,
            criteria?.allowSetting
          );
          existing.denySetting = Math.max(
            existing?.denySetting,
            criteria?.denySetting
          );
        } else {
          combinedData?.securityRulesCriteria.push({ ...criteria });
        }
      });

      // Combine security rules functionality
      group?.securityRulesFunctionality?.forEach((func) => {
        const existing = combinedData?.securityRulesFunctionality?.find(
          (f) =>
            f?.securityRulesFunctionalityID ===
            func?.securityRulesFunctionalityID
        );
        if (existing) {
          existing.allowSetting = Math.max(
            existing?.allowSetting,
            func?.allowSetting
          );
          existing.denySetting = Math.max(
            existing?.denySetting,
            func?.denySetting
          );
        } else {
          combinedData?.securityRulesFunctionality.push({ ...func });
        }
      });

      // Combine security rules records
      group?.securityRulesRecords?.forEach((record) => {
        const existing = combinedData?.securityRulesRecords?.find(
          (r) => r?.securityRulesRecordsID === record?.securityRulesRecordsID
        );
        if (existing) {
          existing.allowSetting = Math.max(
            existing?.allowSetting,
            record?.allowSetting
          );
          existing.denySetting = Math.max(
            existing?.denySetting,
            record?.denySetting
          );
        } else {
          combinedData?.securityRulesRecords.push({ ...record });
        }
      });

      // Combine client params
      group.clientParams.forEach((param) => {
        const existing = combinedData?.clientParams?.find(
          (p) => p.clientParamID === param?.clientParamID
        );
        if (!existing) {
          combinedData?.clientParams?.push({ ...param });
        }
      });
    });

    return combinedData;
  }

  // const { data, error, isLoading } = useSWR(API_ENDPOINTS.refList, getRefList);

  const getLatestBookings = () => {
    let url = API_ENDPOINTS.latestStaffBooking;
    if (user?.staffId === 1) {
      url = API_ENDPOINTS.latestBooking;
    }
    api
      .get(url)
      .then((response) => {
        if (response.status === 200 && response.data) {
          // dispatch(setBookings(response?.data));
          dispatch(setLastBookingsFromAPI(response?.data));
        }
      })
      .catch((error) => {
        console.error(
          "Request failed:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const closeModal = () => {
    resetTimer();
    setShowWarning(false);
  };

  const logout = () => {
    window.location.href = "/login";
  };

  return (
    <>
      <InternetAlert />
      <SetReflist></SetReflist>
      <SetClientParam />
      <SetSecurityRules />
      <SetModulesList />
      <MainContainer ref={mainContainerRef}>
        <Header ref={headerRef} />
        <MainContentWrapper
          align_items={"stretch"}
          className="main-content-flex"
          gap={"20px"}
          headerHeight={headerHeight}
        >
          {!isSidebarHiddenForRoute && <Sidebar headerHeight={headerHeight} />}
          <ContentContainer headerHeight={headerHeight}>
            <Outlet context={{ headerHeight }} />
          </ContentContainer>
        </MainContentWrapper>
      </MainContainer>

      {showWarning && (
        <Modal
          header={"⚠️ Session Expiring Soon"}
          show={showWarning}
          size="md"
          onHide={closeModal}
          handleSubmit={closeModal}
          handleCancel={handleLogout}
          footerCloseActionText="Logout Now"
          footerSubmitButtonText="Continue Session"
          footerActionsNeed={false}
        >
          <p>You’ll be logged out in {countdown} seconds due to inactivity.</p>
          <p>To continue press any key </p>
        </Modal>
      )}
    </>
  );
};

export default App;
